<template>
  <div>
    <h2 class="contentSubTitle mb15">커스텀 필드</h2>
    <div class="mb10"><button class="btn btnWhite">{{ locale.add }}</button></div>
    <!-- <ul class="presets">
      <li v-for="cnt in 5" :key="cnt">
        <button type="button" class="btnDel"></button>
        <p class="name">전송카테고리(POS연동 추가데이터)</p>
        <p class="info">포함 필드: submitCategory 외 2</p>
      </li>
    </ul> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'

export default {
  name: 'ShopPresetCustomField',
  props: [
    'locale'
  ],
  components: {
  },
  computed: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    async init () {
      
    }
  }
}
</script>
